<template>
	<v-card class="mb-3">
		<v-list-item>
			<v-list-item-content>
				<div @click="locumViewBookingRequest(requestSet)">
					<v-list-item-title class="secondary--text lighten-1 font-weight-bold">{{
						('offer' in requestSet ? requestSet.offer.company : requestSet.request).name
					}}</v-list-item-title>
					<v-list-item-subtitle class="black--text subtitle-2 font-weight-bold"
						>{{ dateFormattedMomentjs(requestSet.request.booking_dates[0]) }} -
						{{ dateFormattedMomentjs(requestSet.request.booking_dates[requestSet.request.booking_dates.length - 1]) }}</v-list-item-subtitle
					>

					<v-list-item-subtitle v-if="showTimes" class="pt-0 subtitle-2 black--text font-weight-bold">{{ start_time }} - {{ end_time }}</v-list-item-subtitle>
					<v-list-item-subtitle v-else-if="!showTimes" class="pt-0 subtitle-2 black--text font-weight-bold">Times differ per day</v-list-item-subtitle>

					<v-list-item-subtitle class="primary--text subtitle-2 font-weight-bold"
						>#{{ 'offer' in requestSet ? requestSet.offer.offer_code : requestSet.request.booking_request_ref }}</v-list-item-subtitle
					>
				</div>
				<v-row no-gutters>
					<v-badge :content="unreadMessageCount" :value="unreadMessageCount" color="primary" bottom overlap bordered>
						<v-btn
							v-if="showMessageValid(requestSet.request.booking_dates[requestSet.request.booking_dates.length - 1])"
							class="white--text button-rounded mt-2"
							:height="25"
							color="accent"
							@click="openMessageDialog()"
							><span style="font-size: 12px">Message</span></v-btn
						>
					</v-badge>
				</v-row>
			</v-list-item-content>

			<v-list-item-avatar>
				<v-icon large color="blue lighten-1" @click="locumViewBookingRequest(requestSet)">mdi-chevron-right</v-icon>
			</v-list-item-avatar>
		</v-list-item>
	</v-card>
</template>

<script>
import { mapActions } from 'vuex';
import { bus } from '@/main';
import moment from 'moment';

import store from '@/store';

export default {
	name: 'LocumBookingRequestCard',
	components: {},
	props: {
		requestSet: { type: Object, required: true },
	},

	data: () => ({
		showTimes: true,
		start_time: '',
		end_time: '',
		unreadMessageCount: 0,
	}),

	async mounted() {
		await this.getUnreadMessageCount();
		this.getTimes();
	},

	methods: {
		...mapActions('message', ['GetConversationUnreadCount']),
		locumViewBookingRequest(requestSet) {
			const { offer, availability } = requestSet;

			if (offer) {
				this.viewPrivateRequest(requestSet);
			}
			if (availability) {
				this.viewPublicRequest(requestSet);
			}
		},
		viewPrivateRequest(requestSet) {
			const { offer, request } = requestSet;
			const { booking_dates, booking_dates_times } = request;

			const { id: offerId, company, profession, rates, experience, start_time, end_time, lunch, notes, request_dates, skills } = offer;

			const booking = { start_time, end_time, lunch, notes, booking_dates, booking_dates_times, id: offerId, profession, rates, experience, request_dates, skills };

			store.dispatch('setLocumPracticeRequestSelected', requestSet);
			store.dispatch('setLocumViewingPractice', { id: company.id, booking, source: 'viewBookingRequest' });
			bus.$emit('change-context', 'view-practice-details-card');
		},
		viewPublicRequest(requestSet) {
			const { availability, request } = requestSet;

			const { id: availabilityId, date } = availability;
			const { id: companyId, booking_dates, rates, experience, industry, start_time, end_time, lunch, notes, request_dates, skills } = request;

			const booking = {
				start_time,
				end_time,
				lunch,
				notes,
				booking_dates,
				date,
				industry,
				id: availabilityId,
				rates,
				experience,
				request_dates,
				skills,
			};

			store.dispatch('setLocumPracticeRequestSelected', requestSet);
			store.dispatch('setLocumViewingPractice', { id: companyId, booking, source: 'viewBookingRequest' });
			bus.$emit('change-context', 'view-practice-details-card');
		},
		dateFormattedMomentjs(date) {
			return date ? moment(date).format('MMM Do YYYY') : '';
		},
		getTimes() {
			this.showTimes = true;
			this.start_time = this.requestSet.offer.start_time;
			this.end_time = this.requestSet.offer.end_time;
			for (let index = 0; index < this.requestSet.offer.request_dates.length; index++) {
				if (
					moment(this.requestSet.offer.request_dates[index].start_time).format('HH:mm') !== this.requestSet.offer.start_time ||
					moment(this.requestSet.offer.request_dates[index].end_time).format('HH:mm') !== this.requestSet.offer.start_time
				) {
					this.showTimes = false;
					break;
				}
			}
		},

		openMessageDialog() {
			const sentByID = this.requestSet.request.id;
			let receiverDetails = {
				id: this.requestSet.offer.company.id,
				name: this.requestSet.offer.company.name,
			};
			bus.$emit('show-message-dialog', receiverDetails, sentByID);
			this.unreadMessageCount = 0;
		},

		showMessageValid(reqEndDate) {
			const currentDate = new Date();
			const currentDayOfMonth = currentDate.getDate();
			const currentMonth = currentDate.getMonth(); // Be careful! January is 0, not 1
			const currentYear = currentDate.getFullYear();

			const dateString = currentYear + '-' + (currentMonth + 1).toString().padStart(2, '0') + '-' + currentDayOfMonth.toString().padStart(2, '0');
			if (reqEndDate >= dateString) return true;
			else return false;
		},

		async getUnreadMessageCount() {
			const unreadCount = await this.GetConversationUnreadCount({
				receivedByID: this.requestSet.request.id,
				sentByID: this.requestSet.offer.company.id,
			});
			this.unreadMessageCount = unreadCount;
		},
	},
};
</script>
